import dayjs from 'dayjs';
import Vue from "vue";
import VueRouter from "vue-router";
import { getSetting } from "../api/index.js";
import state from "../store/index.js";
import localStorage from "../utils/localStorage.js";
import Home from "../views/Home.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    // component: () => import("../views/Index.vue"),
    component:()=>import('../views/Auth/Login.vue'),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "首页",
      // auth:false
    },
  },
  // {
  // 	path:'/posts',
  // 	name:'PostsTest',
  // 	component:()=>import('../views/Posts/Posts.vue'),
  // 	meta:{
  // 		title: '文章',
  // 		// auth:false
  // 	}
  // },
  {
    path: "/posts/:uuid([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})",
    name: "Posts",
    component: () => import("../views/Posts/Posts.vue"),
    meta: {
      title: "文章",
      // auth:false
    },
  },
  {
    path: "/info",
    name: "Info",
    component: () => import("../views/Info/Info.vue"),
    meta: {
      title: "资讯",
      // auth:false
    },
  },
  {
    name: "InfoDetail",
    path: "/info/detail",
    component: () => import("../views/InfoDetail/InfoDetail.vue"),
    meta: {
      title: "详情",
      // auth: false
    },
  },
  {
    name: "Contest",
    path: "/contest",
    component: () => import("../views/Contest/Contest.vue"),
    meta: {
      title: "大赛",
      // auth:false
    },
  },
  {
    // ([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})
    path: "/contest/detail/:uuid",
    name: "ContestDetail",
    component: () => import("../views/ContestDetail/ContestDetail.vue"),
    meta: {
      title: "大赛详情",
      // auth: false
    },
  },
  {
    path: "/contest/detail",
    name: "ContestDetailShare",
    component: () => import("../views/ContestDetail/ContestDetail.vue"),
    meta: {
      title: "大赛详情",
      // auth: false
    },
  },
  {
    path:"/contest/worksDetail",
    name:"WorksDetail",
    component:()=>import('../views/ContestDetail/WorksDetail.vue'),
    meta:{
      title:"作品详情"
    }
  },
  {
    path: "/commitment",
    name: "CommitmentDetail",
    component: () => import("../views/ContestDetail/Commitment.vue"),
    meta: {
      title: "11",
      // auth: false
    },
  },
  {
   
    path: "/contestSampleApply",
    name: "ContestSampleApply",
    component: () => import("../views/ContestDetail/ContestSampleApply.vue"),
    meta: {
      title: "样衣申请",
      // auth: false
    },
  },
  {
    name: "UserProfile",
    path: "/userProfile/:code",
    component: () => import("../views/UserProfile/Profile.vue"),
    meta: {
      title: "设计师主页",
    },
  },
  {
    name: "Search",
    path: "/search/:keyword",
    component: () => import("../views/Search/Search.vue"),
    meta: {
      title: "搜索结果",
      // auth: false
    },
  },
  {
    name: "UserAppeal",
    path: "/Appeal/Appeal",
    component: () => import("../views/Appeal/Appeal.vue"),
    meta: {
      title: "侵权申诉",
      // auth: false
    },
  },
  {
    name: "BusinessCooperation",
    path: "/BusinessCooperation/BusinessCooperation",
    component: () =>
      import("../views/BusinessCooperation/BusinessCooperation.vue"),
    meta: {
      title: "商务合作",
    },
  },
  {
    name: "CooperationCases",
    path: "/CooperationCases/CooperationCases",
    component: () =>
      import("../views/CooperationCases/CooperationCases.vue"),
    meta: {
      title: "合作案例",
    },
  },
  {
    name:"CaseDetail",
    path:"/CaseDetail/CaseDetail/:case_id",
    component:()=>import("../views/CasesDetail/CasesDetail.vue"),
    meta:{
      title:"案例详情"
    }
  },
  {
    name:"Mall",
    path:"/Mall",
    component:()=>import("../views/Mall/Index.vue"),
    meta:{
      title:"设计师商城"
    }
  },
  {
    name:"GoodsList",
    path:"/Mall/GoodsList",
    component:()=>import("../views/Mall/GoodsList.vue"),
    meta:{
      title:"商品列表"
    }
  },
  {
    name:"GoodsDetail",
    path:"/Mall/GoodsDetail/:uuid",
    component:()=>import("../views/Mall/GoodsDetail.vue"),
    meta:{
      title:"商品详情"
    }
  },
  {
    name:"MallShopCart",
    path:"/Mall/ShopCart",
    component:()=>import("../views/Mall/ShopCart.vue"),
    meta:{
      title:"购物车"
    }
  },
  {
    name:"MallCheckOut",
    path:"/Mall/CheckOut",
    component:()=>import("../views/Mall/CheckOut.vue"),
    meta:{
      title:"确认订单"
    }
  },
  {
    name:"MallPayOrder",
    path:"/Mall/PayOrder",
    component:()=>import("../views/Mall/Pay.vue"),
    meta:{
      title:"支付订单"
    }
  },
  {
    name:"MallPayResult",
    path:"/Mall/PayResult",
    component:()=>import("../views/Mall/PayResult.vue"),
    meta:{
      title:"支付结果"
    }
  },
  {
    name:"DesignerList",
    path:"/Mall/DesignerList",
    component:()=>import("../views/Mall/DesignerList.vue"),
    meta:{
      title:"设计师"
    }
  },
  {
    name:"MallOrderEvaluate",
    path:"/Mall/OrderEvaluate",
    component:()=>import("../views/Mall/OrderEvaluate.vue"),
    meta:{
      title:"订单评价"
    }
  },
  // {
  // 	path: "/user",
  // 	name: "UserCenter",
  // 	component: () => import('../views/User/UserLayout.vue'),
  // 	redirect: '/user/center',
  // 	children: [
  // 		{
  // 			name: "UserCenter",
  // 			path: "center",
  // 			component: () => import("../views/User/Center.vue"),
  // 			meta: {
  // 				title: "个人中心",
  // 				// auth: true
  // 			}
  // 		},
  // 		{
  // 			name: "Address",
  // 			path: "address",
  // 			component: () => import("../views/User/Address.vue"),
  // 			meta: {
  // 				title: "地址管理",
  // 				// auth: true
  // 			}
  // 		},
  // 	]
  // },
  {
    name:"ShopManage",
    path:"/shop/manage",
    component:()=>import('../views/Shop/Manage/index.vue'),
    meta:{
      title:"我的店铺",
      auth:true
    }
  },
  {
    name:"CustomService",
    path:"/mall/customService",
    component:()=>import('../views/Mall/Services.vue'),
    meta:{
      title:"客户服务",
      auth:false
    }
  },
  {
    name:"Agreements",
    path:"/agreements",
    component:()=>import('../views/Agreement/Agreement2.vue'),
    meta:{
      title:"协议条款",
      auth:false
    }
  },
  {
    path: "/workbench",
    name: "WorkBench",
    component: () => import("../views/WorkBench/Layout.vue"),
    redirect: "/workbench/home",
    children: [
      {
        name: "WorkBenchHome",
        path: "home",
        component: () => import("../views/WorkBench/Home.vue"),
        meta: {
          title: "我的工作台",
          // auth: true
        },
      },
      {
        name: "WorkBenchMyTemplate",
        path: "template",
        component: () => import("../views/WorkBench/MyTemplate.vue"),
        meta: {
          title: "我的款式",
          // auth: true
        },
      },
      {
        name: "OrderCenter",
        path: "/order/center",
        component: () => import("../views/Order/Center.vue"),
        meta: {
          title: "样衣订单",
          // auth: true
        },
      },
      {
        name: "MallOrderCenter",
        path: "/order/mallcenter",
        component: () => import("../views/Order/MallCenter.vue"),
        meta: {
          title: "商城订单",
          // auth: true
        },
      },
      {
        name: "OrderDetail",
        path: "/order/detail",
        component: () => import("../views/Order/Detail.vue"),
        meta: {
          title: "订单详情",
          // auth: true
        },
      },
      {
        name: "MyCreations",
        path: "creations",
        component: () => import("../views/WorkBench/MyCreations.vue"),
        meta: {
          title: "我的笔记",
        },
      },
      {
        name:"MaterialWearHouse",
        path:"materialWearHouse",
        component:()=>import("../views/MaterialWearhouse/Index.vue"),
        meta:{
          title:"自有面辅料库"
        }
      },
      {
        name:"MaterialWearHouseDetail",
        path:"materialWearHouse/detail",
        component:()=>import("../views/MaterialWearhouse/Detail.vue"),
        meta:{
          title:"自有面辅料库详情"
        }
      },
      {
        name: "MyFollow",
        path: "fansfollow/:type",
        component: () => import("../views/WorkBench/FansFollow.vue"),
        meta: {
          title: "我的关注",
        },
      },
      {
        name: "MyFans",
        path: "fansfollow/:type",
        component: () => import("../views/WorkBench/FansFollow.vue"),
        meta: {
          title: "我的粉丝",
        },
      },
      {
        name: "MyInvite",
        path: "myInvite",
        component: () => import("../views/WorkBench/MyInvite.vue"),
        meta: {
          title: "我的邀请",
        },
      },
      {
        name: "OpenShop",
        path: "openShop",
        component: () => import("../views/WorkBench/OpenShop.vue"),
        meta: {
          title: "平台店铺",
        },
      },
      {
        name: "UserCenter",
        path: "center",
        component: () => import("../views/User/Center.vue"),
        meta: {
          title: "个人中心",
          // auth: true
        },
      },
      {
        name: "Address",
        path: "address",
        component: () => import("../views/User/Address.vue"),
        meta: {
          title: "地址管理",
          // auth: true
        },
      },
      {
        name:"UserBalance",
        path:"userBalance",
        component: ()=>import('../views/User/Balance.vue'),
        meta:{
          title:"用户余额"
        }
      },
      {
        name:"UserPoint",
        path:"userPoint",
        component: ()=>import('../views/User/Point.vue'),
        meta:{
          title:"我的积分"
        }
      },
      {
        name:"UserCoupon",
        path:"UserCoupon",
        component: ()=>import('../views/User/Coupon.vue'),
        meta:{
          title:"我的消费券"
        }
      },
      {
        name:"ShopApply",
        path:"shopApply",
        component: ()=>import('../views/WorkBench/ShopApply.vue'),
        meta:{
          title:"店铺申请"
        }
      },
      {
        name:"Agreement",
        path:"agreement",
        component:()=>import('../views/Agreement/Agreement.vue'),
        meta:{
          title:"服务协议"
        }
      },
      {
        name:"MallCollection",
        path:"mallCollection",
        component:()=>import('../views/Mall/Collect.vue'),
        meta:{
          title:"收藏心仪"
        }
      },
      {
        name:"MyTeam",
        path:"myTeam",
        component:()=>import('../views/Team/Index.vue'),
        meta:{
          title:"我的团队"
        }
      },
      {
        path:"patternMakerOrder",
        name:"PatternMakerOrder",
        component:()=>import('../views/PatternMaker/Order.vue'),
        meta:{
          title:"打版订单"
        }
      },
      {
        path:"mall/order/serviceApply",
        name:"ServiceApply",
        component: () => import("../views/Mall/OrderService/ServiceApply.vue"),
        meta:{
          title:"申请售后",
          auth:true
        }
      },
      {
        path:"mall/order/serviceDetail",
        name:"ServiceDetail",
        component: () => import("../views/Mall/OrderService/ServiceDetail.vue"),
        meta:{
          title:"售后详情",
          auth:true
        }
      },
      {
        path:"procurementOrder",
        name:"ProcurementOrder",
        component:()=>import('../views/Procurement/Order.vue'),
        meta:{
          title:"代购订单"
        }
      },
      {
        path:"matchLog",
        name:"MatchLog",
        component:()=>import('../views/ContestLog/ContestLog.vue'),
        meta:{
          title:'参赛记录'
        }
      }
    ],
  },
  {
    path: "/workbench/design",
    name: "WorkBenchDesign",
    component: () => import("../views/WorkBench/DesignV3ReCoding/index.vue"),
    meta: {
      title: "创建设计",
      auth: true,
    },
  },
  // {
  //   path: "/workbench/design",
  //   name: "WorkBenchDesign",
  //   component: () => import("../views/WorkBench/DesignV3/Main.vue"),
  //   meta: {
  //     title: "创建设计",
  //     auth: true,
  //   },
  // },
  {
		path:"/workbench/quickdesign",
		name:"QuickDesign",
		component:()=>import('../views/WorkBench/QuickDesign.vue'),
		meta:{
			title:"快速定制",
			auth:true
		}
	},
  {
    path: "/workbench/summary",
    name: "WorkBenchSummary",
    component: () => import("../views/WorkBench/Summary.vue"),
    meta: {
      title: "款式确定页",
      auth: true,
    },
  },
  {
    path: "/summary_outer",
    name: "WorkBenchSummaryOuter",
    component: () => import("../views/WorkBench/SummaryOuter.vue"),
    meta: {
      title: "订单信息",
      auth: false,
    },
  },
  {
    path: "/order/checkout",
    name: "WorkBenchCheckout",
    component: () => import("../views/Order/Checkout.vue"),
    meta: {
      title: "订单确认页",
      auth: true,
    },
  },
  {
    path: "/order/cashdesk",
    name: "CashDesk",
    component: () => import("../views/Order/CashDesk.vue"),
    meta: {
      title: "正在支付",
      auth: true,
    },
  },
  {
    path: "/order/makeup",
    name: "Makeup",
    component: () => import("../views/Order/Makeup.vue"),
    meta: {
      title: "正在支付",
      auth: true,
    },
  },
  {
    path: "/order/result",
    name: "PayResult",
    component: () => import("../views/Order/PayResult.vue"),
    meta: {
      title: "支付结果",
      auth: false,
    },
  },
  {
    name: "ShopHome",
    path: "/shop/home",
    // component: () => import("../views/Shop/Home.vue"),
    component:()=>import("../views/Shop/Index.vue"),
    meta: {
      title: "我的店铺",
      auth: false,
    },
  },
  {
    name: "ShopManage",
    path: "/shop/manage1",
    component: () => import("../views/Shop/Product/Manage.vue"),
    meta: {
      title: "商品管理",
      auth: true,
    },
  },
  {
    name: "ProductEdit",
    path: "/shop/product/edit",
    component: () => import("../views/Shop/Product/Edit.vue"),
    meta: {
      title: "商品维护",
      auth: true,
    },
  },
  {
    name: "ProductDetail",
    path: "/shop/product/detail",
    component: () => import("../views/Shop/Product/Detail.vue"),
    meta: {
      title: "商品详情",
      auth: false,
    },
  },
  {
    name: "FabricDetail",
    path: "/order/fabric_detail",
    component: () => import("../views/Order/FabricDetail.vue"),
    meta: {
      title: "面料详情单",
      // auth: true
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Auth/Register.vue"),
    meta: {
      title: "注册",
      auth: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Auth/Login.vue"),
    meta: {
      title: "登录",
      auth: false,
    },
  },
  {
    path: "/findpwd",
    name: "FindPwd",
    component: () => import("../views/Auth/FindPwd.vue"),
    meta: {
      title: "找回密码",
      auth: false,
    },
  },
  {
    path: "/submit-result",
    name: "SubmitResult",
    component: () => import("../views/SubmitResult/SubmitResult.vue"),
    meta: {
      title: "提交成功",
      auth: false,
    },
  },
  {
    path: "/fabricHall",
    name: "FabricHall",
    component: () => import("../views/FabricHall/Home.vue"),
    meta: {
      title: "面料馆",
      auth: false,
    },
  },
  {
    path: "/fabricHallSearch",
    name: "FabricHallSearch",
    component: () => import("../views/FabricHall/Search.vue"),
    meta: {
      title: "面料馆",
      auth: false,
    },
  },
  // {
  //   path: "/fabricHallSearch",
  //   name: "FabricHallSearch",
  //   component: () => import("../views/FabricHall/Search.vue"),
  //   meta: {
  //     title: "面料馆",
  //     auth: false,
  //   },
  // },
  {
    path: "/fabricHallDetail",
    name: "FabricHallDetail",
    component: () => import("../views/FabricHall/Detail.vue"),
    meta: {
      title: "面料馆",
      auth: false,
    },
  },
  {
    path:"/patternMakerRegister",
    name:"PMRegister",
    component:()=>import('../views/PatternMaker/Register.vue'),
    meta:{
      title:"版师入驻",
      auth:false
    }
  },
  {
    path:"/pmRegister",
    name:"PMRegisterForm",
    component:()=>import('../views/PatternMaker/RegisterForm.vue'),
    meta:{
      title:"版师入驻申请",
      auth:false
    }
  },
  {
    path:"/pmResult",
    name:"PMResult",
    component:()=>import('../views/PatternMaker/RegisterResult.vue'),
    meta:{
      title:"版师入驻结果",
      auth:false
    }
  },
  {
    path:"/workbench/patternMakerOrderDetail",
    name:"PatternMakerOrderDetail",
    component:()=>import('../views/PatternMaker/OrderDetail.vue'),
    meta:{
      title:"打板订单详情"
  }
  },

  {
    path:"/procurementApply",
    name:"ProcurementApply",
    component:()=>import('../views/Procurement/Register.vue'),
    meta:{
      title:"代购员申请",
      auth:false
  }
  },
  {
    path:"/procurementRegister",
    name:"ProcurementRegister",
    component:()=>import('../views/Procurement/RegisterForm.vue'),
    meta:{
      title:"代购员入驻申请",
      auth:false
    }
  },
  {
    path:"/procurementResult",
    name:"ProcurementResult",
    component:()=>import('../views/Procurement/RegisterResult.vue'),
    meta:{
      title:"代购员入驻结果",
      auth:false
    }
  },
  {
    path:"/workbench/procurementOrderDetail",
    name:"ProcurementOrderDetail",
    component:()=>import('../views/Procurement/OrderDetail.vue'),
    meta:{
      title:"代购订单详情"
    }
  },
  {
    path: "/:uuid([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})",
    name: "PostDetail",
    component: Home,
    meta: {
      title: "",
    },
  },
  {
    path: "/:uuid([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/:code",
    name: "PostDetailShare",
    component: Home,
    meta: {
      title: "",
    },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/404.vue"),
    meta: {
      title: "页面未找到",
    },
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if(from.name === 'FabricHallDetail' && savedPosition){
      return new Promise(resolve=>{
        console.log('aaaa-scrollbehavior');
        //>防止跳转时数据没有加载完成，等待500ms
        setTimeout(()=>{
          console.log('aaa-position');
          resolve(savedPosition);
        },500);
      })
    }
    // 总是滚动到顶部
    return { x: 0, y: 0 };

    // 或者如果你希望恢复之前保存的位置（如浏览器前进/后退）
    // return savedPosition || { x: 0, y: 0 };
  },
});
router.beforeEach(async (to, from, next) => {
  const defaultTitle = '衣创社区';
  const title = to.meta.title && to.meta.title.trim() ? to.meta.title : defaultTitle;
  document.title = title;

  //>拒绝从支付页回退checkout,避免报错以及订单重复创建
  if(from.name === 'MallPayOrder' && to.name === 'MallCheckOut'){
    next({path:"/order/mallcenter"});
  }
  if (to.params.code || to.query.code) {
    let code = to.params.code || to.query.code;
    state.commit("setParentCode", code);
  }
  if (to.query.channel) {
    state.commit("setChannel", to.query.channel);
  }
  await state.dispatch("checkExpiredTime");

  //检查是否加载了配置
  if (!state.getters.isSettingLoad()) {
    getSetting({}).then((response) => {
      state.commit("updateSetting", response.data);
    });
  }

  //>检查登录状态
  const isLogin = state.is_login;
  const expired_time = localStorage.get('expired_time');

  //>如果用户处于“已登录”状态，必须检查 Token 是否过期
  if (isLogin) {
    //>如果没有过期时间，或者格式错误，视为无效登录
    if (!expired_time || expired_time === 'undefined' || expired_time === 'null') {
      console.warn('[Router] 已登录但无有效过期时间，强制登出');
      state.commit('clearLoginState');
      if(to.matched.some((record)=>record.meta.auth)){
        next({
          path:'/login',
          query:{
            redirect:to.fullPath
          }
        });
      }
      return;
    }

    //>计算是否过期
    const now = dayjs();
    const expired = dayjs(parseInt(expired_time, 10) * 1000);

    if (now.isAfter(expired)) {
      console.log('[Router] Token 已过期，强制登出');
      state.commit('clearLoginState');
      if(to.matched.some((record)=>record.meta.auth)){
        next({
          path:'/login',
          query:{
            redirect:to.fullPath
          }
        });
      }
      return;
    }
    
    //>Token 有效，允许通行
    next();
  } else {
    next(); 
  }

  // if (to.matched.some((record) => record.meta.auth)) {
  //   if (state.getters.isLoginDynamic()) {
  //     next();
  //   } else {
  //     state.commit("update_login_state", false);
  //     next({
  //       path: "/login",
  //       query: {
  //         redirect: to.fullPath,
  //       },
  //     });
  //   }
  // } else {
  //   next();
  // }
});

export default router;
